import { AppConfigModel, GetTokenBindingModel, GetTokenViewModel } from './../../../api/models/base.model';
import { BaseComponent } from './../../../layout/main/base.component';
import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';

import { AppConstants } from 'src/app/app.constants';
import { Customer, EmailStatus, ItemCode, SendEmailVerificationBindingModel } from 'src/app/api/models/web-booking.models';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent extends BaseComponent implements OnInit {

  form: any;

  ngOnInit(): void {
    this.form = this.app.formBuilder
      .group(
        {
          email: new FormControl('', [Validators.required, Validators.email]),
          password: new FormControl('', [Validators.required, Validators.minLength(6)])
        }
      );

    this.baseTriggerChild.subscribe(event => {
      this.app.spinner.hide();
      if (this.app.branch == null) { 
        this.app.router.navigate([AppConstants.RouteSelectConsultation]); return; 
      }
      if(this.app.config.loginEnableStartUpPopUpMessage)
      {
        this.app.showConfirmDialog(
          this.app.config.loginStartUpPopUpMessageContent, 
          this.app.config.loginStartUpPopUpContinueButtonText,
          this.app.config.loginStartUpPopUpTitleText);
      }
    });
    this.start();
  }

  forgotPassword(): void {
    this.app.router.navigate([AppConstants.RouteForgotPassword]);
  }

  checkEmail(): void {
    this.app.spinner.show();
    this.app.webBookingService.CheckEmailStatus(this.form.getRawValue())
      .subscribe(
        data => {
          if (data.status === EmailStatus.Blocked) {
            this.app.spinner.hide();
            this.showErrorMessage('Email address is suspended.');
          }
          else if (data.status === EmailStatus.EmailVerified) {
            this.getToken();
          }
          else if (data.status === EmailStatus.ForCustomerMigration) {
            this.app.spinner.hide();
            this.sendMigrationLink();
          }
          else if (data.status === EmailStatus.WaitingForEmailVerification) {
            this.app.spinner.hide();
            this.sendEmailVerification();
          }
          else if (data.status === EmailStatus.NotYetRegistered) {
            this.app.spinner.hide();
            this.showErrorMessage('Email address is not yet registered.');
          }
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  getToken(): void {
    const formModel = this.form.getRawValue();
    const model: GetTokenBindingModel =
    {
      username: formModel.email,
      email: formModel.email,
      password: formModel.password,
      grand_type: 'password'
    };

    this.app.spinner.show();
    this.app.webBookingService.GetToken(model)
      .subscribe(
        data => {
          data.created_date = this.app.dateService.formatDateTime(new Date());
          this.app.storageService.setItem(AppConstants.Token, JSON.stringify(data));
          this.getProfile();
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  getProfile(): void {
    this.app.webBookingService.GetProfile()
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.app.customer = data;
          this.app.storageService.setItem(AppConstants.Customer, JSON.stringify(this.app.customer));
          
          this.app.storageService.removeItem(AppConstants.GiftVoucherSelectedVouchers);
          this.app.basketItems = null;
          this.app.reCompute();

          this.checkCustomerData();
          this.redirectToNextPage();
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  register(): void {
    this.app.router.navigate([AppConstants.RouteRegister]);
  }

  sendMigrationLink(): void {
    const formModel = this.form.getRawValue();
    this.app.spinner.show();
    const m = {
      email: formModel.email,
      branchId: this.app.branch.branchId
    };
    this.app.webBookingService.SendMigrationLink(m)
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.app.storageService.setItem(AppConstants.CustomerId, data.customerId);
          this.app.storageService.setItem(AppConstants.CustomerEmail, formModel.email);
          this.showInfoMessage('Please check your email to get your online account activation code');
          this.app.router.navigate([AppConstants.RouteMigrateCustomer]);
        },
        error => {
          this.showErrorMessage(error);
        });
  }

  sendEmailVerification(): void {
    const formModel = this.form.getRawValue();
    this.app.spinner.show();
    const m = new SendEmailVerificationBindingModel();
    m.email = formModel.email;
    this.app.webBookingService.SendEmailVerification(m)
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.app.storageService.setItem(AppConstants.CustomerId, data.customerId);
          this.app.storageService.setItem(AppConstants.CustomerEmail, formModel.email);
          this.showInfoMessage('Please check your email to get your email verification code');
          this.app.router.navigate([AppConstants.RouteVerifyEmailAddress]);
        },
        error => {
          this.showErrorMessage(error);
        });
  }
}
